import clsx from 'clsx'

export default function LoadingSpinner({ size = 'md', className }) {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-10 h-10 border-3',
    xl: 'w-16 h-16 border-4',
  }

  return (
    <div
      className={clsx(
        'rounded-full border-gray-200 border-t-primary-600 animate-spin',
        sizes[size],
        className
      )}
    />
  )
}

export function LoadingOverlay({ message = '加载中...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-gray-500">{message}</p>
    </div>
  )
}
